import React, { useEffect, useState } from "react";

import * as Yup from "yup";
import { toast } from "react-toastify";
import { useFormik } from "formik";
import { useNavigate, useParams } from "react-router-dom";
import trans, { isRTL } from "../../../../utils";
import { editData, storeData } from "../../../../utils/IndexedDB";
import OfflineFormHeader from "../../OfflineFormControl/OfflineFormHeader/OfflineFormHeader";
import OfflineFormFooter from "../../OfflineFormControl/OfflineFormFooter/OfflineFormFooter";
import SnagOfflineFormInformation from "./SnagOfflineFormInformation";
import SnagOfflineFormSnagData from "./SnagOfflineFormSnagData";
import Button from "../../../Helpers/Button/Button";
import { useSelector } from "react-redux";

export default function SnagOfflineForm({
	formBody,
	formEditData,
	setRoomId,
	roomId,
}) {
	const inf = useSelector((state) => state.users.user);
	const [submitAttempt, setSubmitAttempt] = useState(false);
	const navigate = useNavigate();
	const param = useParams();
	const snagData = () => ({
		sector: formBody?.snagOptions?.sectors?.[0],
		assigned_to_id: null,
		subsystem: null,
		discipline: formBody?.snagOptions?.disciplines?.[0],
		item: null,
		description: null,
		asset_tag_id: null,
		drawing_ref: null,
		area_room: null,
		location: formBody?.level?.name,
		severity: null,
		acceptance_criteria: null,
		inspection_method: null,
		location_details: null,
		target_date: null,
		files: [],
	});

	let initialValues = {
		type: "SNAG",
		project_id: null,
		discipline: null,
		zone_id: null,
		level: null, // building_id maps to level in IR
		room_id: null, // level (space poiId) maps to room_id in IR
		room_name: null,
		snags: [snagData()],
	};
	const snagSchema = Yup.object({
		assigned_to_id: Yup.string().required(trans("Assign To is required")),
		description: Yup.string().required(trans("Description is required")),
		subsystem: Yup.string().required(trans("Subsytem is required")),
		files: Yup.array().of(Yup.mixed()).notRequired(),
	});
	let validSchema = Yup.object({
		room_id: Yup.string().required(trans("Space is required")),
		snags: Yup.array()
			.of(snagSchema)
			.min(1, trans("At least one snag is required")),
	});
	let addSnag = useFormik({
		initialValues,
		validationSchema: validSchema,
		onSubmit: async (val) => {
			try {
				if (!param?.id) {
					await storeData("OfflineModeData", "Snag", `Snag-${Date.now()}`, {
						id: Date.now(),
						userId: inf?.id,
						status: "Pending Sync",
						configurationName: formBody?.name,
						...val,
					});
					toast.success(trans("Snag Form Submitted Successfully"), {
						autoClose: 800,
						rtl: localStorage.getItem("lang") === "ar" ? true : false,
					});
				} else {
					await editData("OfflineModeData", "Snag", param.id, {
						...val,
						configurationName: formBody?.name,
						id: param.id,
						status: "Pending Sync",
					});

					toast.success(trans("Snag Form Edited Successfully"), {
						autoClose: 800,
						rtl: localStorage.getItem("lang") === "ar",
					});
				}

				navigate("/snag-list");
				// }
			} catch (error) {
				console.log("errr", error);
			}
		},
	});

	useEffect(() => {
		addSnag.setFieldValue("project_id", formBody?.project?.id);
		addSnag.setFieldValue("level", formBody?.level?.id);
		addSnag.setFieldValue("project_name", formBody?.project?.name);
		addSnag.setFieldValue("level_name", formBody?.level?.name);
		const updatedSnags = addSnag.values.snags?.map((snag) => ({
			...snag,
			sector: formBody?.snagOptions?.sectors?.[0],
			discipline: formBody?.snagOptions?.disciplines?.[0],
			location: formBody?.level?.name,
		}));

		addSnag.setFieldValue("snags", updatedSnags);
		if (!param?.id) {
			addSnag.setFieldValue("zone_id", formBody?.building?.id);
			addSnag.setFieldValue("zone_name", formBody?.building?.name);
			addSnag.setFieldValue(
				"discipline",
				formBody?.modules
					?.filter((j) => j.module === "SNAG")
					?.map((i) => {
						return i.discipline;
					})?.[0],
			);
		} else {
			addSnag.setFieldValue("zone_id", formEditData?.zone_id);
			addSnag.setFieldValue("zone_name", formEditData?.zone_name);
			addSnag.setFieldValue("discipline", formEditData?.discipline);
			addSnag.setFieldValue("room_id", formEditData?.room_id);
			addSnag.setFieldValue("room_name", formEditData?.room_name);
			addSnag.setFieldValue("snags", formEditData?.snags);
		}
	}, [formBody, param.id]);
	console.log("FormBody", formBody);
	// useEffect(() => {
	// 	addSnag.setFieldValue("fields", submitData);
	// }, [submitData]);
	useEffect(() => {
		if (addSnag.values.room_name) {
			const updatedSnags = addSnag.values.snags?.map((snag) => ({
				...snag,
				area_room: addSnag.values.room_name,
			}));

			addSnag.setFieldValue("snags", updatedSnags);
		}
	}, [addSnag.values.room_name]);
	useEffect(() => {
		if (roomId) {
			addSnag.setFieldValue("room_id", roomId);
			const roomLabel = formBody?.rooms?.find(
				(i) => i?.poiId === roomId,
			)?.displayName;
			addSnag.setFieldValue("room_name", roomLabel);
		}
	}, [roomId]);
	const handleSubmit = async (e) => {
		e.preventDefault();
		setSubmitAttempt(true);

		addSnag.handleSubmit(e);
	};
	console.log("SnagData", addSnag);
	console.log("roomId", roomId);

	return (
		<div className="col-lg-5">
			<form
				onSubmit={handleSubmit}
				style={{
					width: "100%",
					backgroundColor: "white",
					height: "calc(100vh - 64px)",
					display: "flex",
					flexDirection: "column",
					borderLeft: !isRTL && "1px solid #D2D5DC",
					borderRight: isRTL && "1px solid #D2D5DC",
				}}
			>
				<OfflineFormHeader
					title={!formEditData ? "New Snag" : "Edit Snag"}
					subtitle="Working Offline — Your data will sync when connection returns"
				/>
				<div
					style={{
						flex: 1,
						overflow: "auto",
						display: "flex",
						flexDirection: "column",
						minHeight: 0, // Important for proper scrolling
					}}
				>
					<SnagOfflineFormInformation
						addData={addSnag}
						formBody={formBody}
						formEditData={formEditData}
					/>
					<SnagOfflineFormSnagData
						addData={addSnag}
						formBody={formBody}
						formEditData={formEditData}
					/>
					<Button
						text={trans("Add Another Snag")}
						htmlType="button"
						type="default"
						style={{
							width: "fit-content",
							margin: "auto",
							marginBottom: "6px",
						}}
						onClick={() =>
							addSnag.setFieldValue("snags", [
								...addSnag.values.snags,
								snagData(),
							])
						}
					/>
				</div>
				<OfflineFormFooter
					submitAttempt={submitAttempt}
					addConfig={addSnag}
					route="snag-list"
				/>
			</form>
		</div>
	);
}
